import { Divider, Flex, Title } from '@bb/elements-web';
import React from 'react';
import styled from 'styled-components';

type StepPanelProps = {
  title: string;
};

const StepPanel: React.FC<StepPanelProps> = ({ children, title }) => (
  <StyledFlex vertical>
    <StyledTitle level={4} dataCy={`stepPanel-${title}`} textAlign="center">
      {title}
    </StyledTitle>
    <Divider />
    {children}
  </StyledFlex>
);

const StyledFlex = styled(Flex)`
  width: 100%;
`;

const StyledTitle = styled(Title)`
  && {
    margin: 0;
  }
`;

export default StepPanel;
